import React, { Component } from 'react';

export class TickCross extends Component {

    render() {

        return (
            <span>
                {
                    this.props.hidden || (this.props.ticked === null)
                        ? <span />
                        : this.props.ticked
                            ? <img alt='tick' src={require('../../../images/Tick.png')} height={this.props.height} />
                            : <img alt='cross' src={require('../../../images/Cross.png')} height={this.props.height} />
                }
            </span>
        );
    }
}